import { render, staticRenderFns } from "./TransportItem.vue?vue&type=template&id=481fb764&lang=pug&"
import script from "./TransportItem.vue?vue&type=script&lang=ts&"
export * from "./TransportItem.vue?vue&type=script&lang=ts&"
import style0 from "./TransportItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports